import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ImageGallery = ({ images, productName }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);

  const handlePrevious = () => {
    setSelectedImage((prev) => (prev === 0 ? images?.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSelectedImage((prev) => (prev === images?.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="space-y-4">
      {/* Main Image Display */}
      <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-[rgba(14,165,233,0.05)] border border-[rgba(14,165,233,0.2)] shadow-lg">
        {/* Blurred Vial Background Layer - 75% blur */}
        <div className="absolute inset-0">
          <Image
            src="/assets/images/injection-bottle-glass-vial-with-blank-white-label_53876-165420-1770528727675.jpg"
            alt=""
            className="w-full h-full object-cover blur-sm scale-110"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>
        
        {/* INF Logo Overlay - Prominent */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-20">
          <img
            src="/assets/images/Copy_of_Black_White_Modern_Handwritten_Square_Studio_Logo-removebg-preview-1770507171149.png"
            alt="INF LABS"
            className="w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 object-contain opacity-50 drop-shadow-2xl"
          />
        </div>

        {/* Zoom Button */}
        {images?.length > 1 && (
          <>
            <button
              onClick={handlePrevious}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-card/90 backdrop-blur-sm border border-border flex items-center justify-center transition-all duration-250 hover:bg-primary/20 hover:border-primary"
              aria-label="Previous image"
            >
              <Icon name="ChevronLeft" size={20} color="var(--color-primary)" />
            </button>
            <button
              onClick={handleNext}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-card/90 backdrop-blur-sm border border-border flex items-center justify-center transition-all duration-250 hover:bg-primary/20 hover:border-primary"
              aria-label="Next image"
            >
              <Icon name="ChevronRight" size={20} color="var(--color-primary)" />
            </button>
          </>
        )}

        <div className="absolute bottom-4 right-4 px-3 py-1.5 rounded-lg bg-card/90 backdrop-blur-sm border border-border">
          <span className="text-sm font-medium text-foreground data-text">
            {selectedImage + 1} / {images?.length}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 md:gap-3">
        {images?.map((image, index) => (
          <button
            key={index}
            onClick={() => setSelectedImage(index)}
            className={`aspect-square rounded-lg overflow-hidden border-2 transition-all duration-250 ${
              selectedImage === index
                ? 'border-primary shadow-lg shadow-primary/30'
                : 'border-border hover:border-primary/50'
            }`}
          >
            <Image
              src={image?.url}
              alt={image?.alt}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;